import React from "react";
import ShiftCalendar from "./ShiftCalendar";

const PeopleView = () => {
  return (
    <div>
      <ShiftCalendar />
    </div>
  );
};

export default PeopleView;
